import { decodeHtml as commonDecodeHtml, deleteMarketoCookie as commonDeleteMarketoCookie, isTouchDevice as commonIsTouchDevice } from '../utils/utils.common';
import filterXSS from "xss";

const breakpointWatch = {
    data() {
        return {
            breakpoint: String
        }
    },
    created() {
        window.addEventListener('resize', this.breakpointWatchSetBreakpoint);

        this.breakpointWatchSetBreakpoint();
    },
    methods: {
        breakpointWatchSetBreakpoint() {
            this.breakpoint = breakpoint;
        },
        breakpointIsTabletOrSmaller() {
            return this.breakpoint;
        }
    },
    computed: {
        breakpointUpdated: function() {
            return this.breakpoint;
        }
    }
};

const decodeHtml = {
    methods: {
        decodeHtml(html) {
            return commonDecodeHtml(html);
        }
    }
};

const isTouchDevice =  {
    methods: {
        isTouchDevice() {
            return commonIsTouchDevice();
        }
    }
};

const initializeToolTips = {
    methods: {
        initializeToolTips(tippy) {
            this.$el.querySelectorAll('[data-tippy-content]')
            .forEach(element => {
                const theme = element.dataset.tippyTheme || 'classico';
                const placement = element.dataset.tippyPlacement || 'top';
    
                tippy(element, {
                    theme,
                    interactive: true,
                    interactiveBorder: 10,
                    allowHTML: true,
                    animation: false,
                    placement
                });
            });
        }
    }
};

const deleteMarketoCookie = {
    methods: {
       deleteMarketoCookie() {
            return commonDeleteMarketoCookie();
        }
    }
};

const sanitizeHtml = {
    methods: {
        sanitizeHtml(value) {
            return filterXSS(value).replace(/(<([^>]+)>)/gi, '');
        }
    }
};

export {
    breakpointWatch,
    decodeHtml,
    deleteMarketoCookie,
    sanitizeHtml,
    initializeToolTips,
    isTouchDevice
};